import * as React from 'react';
import LoginFormEmailOnly from './LoginFormEmailOnly/LoginFormEmailOnly';
import AppDocumentWrapper from './FormComponents/AppDocumentWrapper';
import OldLogin from './OldLogin';
import './login.scss';

class LoginEmailOnly extends OldLogin {
  render() {
    return (
      <div className="Login" id="it-LoginEmailOnly">
        <AppDocumentWrapper footerConfig={null}>
          <LoginFormEmailOnly />
        </AppDocumentWrapper>
      </div>
    );
  }
}

export default LoginEmailOnly;
